define([
	'internal_util/Util'
], function (
		Util
		) {
	'use strict';

	/**
	 * CloudIdentity class
	 * 
	 * @param {string} id Unique ID of the CloudID ('jti').
	 * @param {string} cloudIdentity Raw, complete base64 encoded and '.' seperated CloudID.
	 * @param {string} issuer Issuer of the CloudID ('iss').
	 * @param {int} validFrom Issued at time ('iat').
	 * @param {int} validUntil Expiration time ('exp').
	 * @param {Array} attributes Array of Attribute objects containing info about the attributes contained in the 
	 * encrypted payload.
	 * @param {Array} bindingProtocol Info about the bindings used to secure the CloudID.
	 * @param {string} idType Type (URI) of the CloudID ('id-type'), e.g. "http://ws.skidentity.de/ci/v2.0".
	 * @param {string} salt Salt for password-based key derivation.
	 * @param {boolean} enabled Flag indicating whether CloudID is enabled.
	 */
	return function (id, cloudIdentity, issuer, validFrom, validUntil,
			attributes, bindingProtocol, idType, salt, enabled) {
		var _cloudIdentity,
				_id,
				_issuer = null,
				_validFrom,
				_validUntil,
				_attributes,
				_bindingProtocol = null,
				_idType,
				_salt = null,
				_enabled,
				self = this;

		if (Util.isValidString(id)) {
			_id = id;
		} else {
			throw new Error('invalid CloudID id: ' + id);
		}

		if (Util.isValidString(cloudIdentity)) {
			_cloudIdentity = cloudIdentity;
		} else {
			throw new Error('invalid CloudID cloudIdentity: ' + cloudIdentity);
		}

		if (Util.isValidString(issuer) || issuer === null) {
			_issuer = issuer;
		} else {
			throw new Error('invalid CloudID issuer: ' + issuer);
		}

		if (Util.isValidDate(validFrom)) {
			_validFrom = validFrom * 1000;
		} else {
			throw new Error('invalid CloudID validFrom: ' + validFrom);
		}

		if (Util.isValidDate(validUntil)) {
			_validUntil = (validUntil /*- 157680000 +2419200-259200+ (60*5)*/) * 1000;
		} else {
			throw new Error('invalid CloudID validUntil: ' + validUntil);
		}

		if (Util.isArray(attributes)) {
			_attributes = attributes;
		} else {
			throw new Error('invalid CloudID attributes: ' + attributes);
		}

		if (Util.isArray(bindingProtocol)) {
			_bindingProtocol = bindingProtocol;
		} else {
			throw new Error('invalid CloudID bindingProtocol: ' + bindingProtocol);
		}

		if (Util.isValidString(idType)) {
			_idType = idType;
		} else {
			throw new Error('invalid CloudID id-type: ' + idType);
		}

		if (Util.isValidString(salt) || salt === null) {
			_salt = salt;
		} else {
			throw new Error('invalid CloudID salt: ' + salt);
		}

		if (typeof enabled === 'boolean') {
			_enabled = enabled;
		} else {
			throw new Error('invalid CloudID enabled: ' + enabled);
		}


		// public methods

		this.id = function () {
			return _id;
		};

		this.cloudIdentity = function () {
			return _cloudIdentity;
		};

		this.issuer = function () {
			return _issuer;
		};

		this.validFrom = function () {
			return new Date(_validFrom);
		};

		this.validUntil = function () {
			return new Date(_validUntil);
		};

		this.attributeIdentifiers = function () {
			var attId = Array();
			for (var i = 0; i < _attributes.length; i++) {
				attId.push(_attributes[i].name());
			}
			return attId;
		};

		/**
		 * Get the attributes contained in this CloudIdentity.
		 * 
		 * @returns {Array} Array of Attribute objects.
		 */
		this.attributes = function () {
			return _attributes;
		};

		this.bindingProtocol = function () {
			return _bindingProtocol;
		};

		/**
		 * Get the ID Type (claim 'id-type').
		 * 
		 * @returns {string} ID Type.
		 */
		this.idType = function () {
			return _idType;
		};

		this.salt = function () {
			return _salt;
		};

		this.isEnabled = function () {
			return _enabled;
		};

		this.enable = function () {
			_enabled = true;
		};

		this.disable = function () {
			_enabled = false;
		};

		this.isEncrypted = function () {
//			return null !== Util.find(_bindingProtocol, function (binding) {
//				return binding.type() === 'http://ws.skidentity.de/ci/binding/password/v1.0';
//			});
			return _salt !== null;
		};
		
		this.getEncryptionSalt = function () {
			if (self.isEncrypted()) {
				return Util.find(_bindingProtocol, function (binding) {
					return binding.type() === 'http://ws.skidentity.de/ci/binding/password/v1.0';
				}).salt();
			}
			return null;
		};

		this.isValid = function () {
			var currentDate = (new Date()).getTime();

			return (_validUntil > currentDate);
		};

		this.isUsable = function () {
			return (this.isValid() && this.isEnabled());
		};

		/**
		 * Get the main origin of this CloudIdentity.
		 * The main origin is the origin of the first eIdentifier contained in this CloudIdentity.
		 * 
		 * @returns {Origin|null} the main origin of this CloudIdentity, or null if not present.
		 */
		this.origin = function () {
			var attributeEID = Util.find(_attributes, function (attribute) {
				return null !== attribute.name().match(/eIdentifier$/);
			});
			return (attributeEID === null) ? null : attributeEID.origin();
		};

		this.toObject = function () {
			return {
				cloudIdentity: _cloudIdentity,
				bindings: Util.serialize(_bindingProtocol),
				enabled: _enabled,
				salt: _salt
			};
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/CloudIdentity.js
// module id = 72
// module chunks = 3